import React, { useMemo } from 'react';

import Spinner from '@components/Spinner';
import useRecommendedProjects from '@hooks/useRecommendedProjects';
import { capitalizeTopic } from '@utils/formatting';

import ProjectCards from './ProjectCards';
import MyTISection from './Section';
import { MY_TI_ENGAGEMENT_LABELS, MY_TI_SECTION_IDS } from './constants';
import useRegisterSection from './useRegisterSection';

interface MyTIDataToolsProps {
  mostReadTopic?: string;
}

const MyTIDataTools = ({ mostReadTopic }: MyTIDataToolsProps) => {
  const { projects, isLoadingProjects } = useRecommendedProjects(mostReadTopic);

  const dataToolsDisplayText = useMemo(() => {
    if (!projects) return MY_TI_ENGAGEMENT_LABELS.NotEngaged.Pro.DataTools;

    const engaged = MY_TI_ENGAGEMENT_LABELS.Engaged.Pro.DataTools;
    const label = mostReadTopic
      ? `Related to ${capitalizeTopic(mostReadTopic)} Coverage`
      : engaged.label;

    return { ...engaged, label };
  }, [projects, mostReadTopic]);

  useRegisterSection(MY_TI_SECTION_IDS.DataTools, isLoadingProjects || !!projects);

  if (!isLoadingProjects && !projects) return null;

  return (
    <MyTISection
      id={MY_TI_SECTION_IDS.DataTools}
      highlight={dataToolsDisplayText.label}
      subtitle={dataToolsDisplayText.subtitle}
      title={dataToolsDisplayText.title}
    >
      {!isLoadingProjects && projects ? (
        <div className="mt-32 flex w-full flex-row flex-wrap justify-center gap-32 md:grid md:grid-cols-3 md:gap-64">
          <ProjectCards projects={projects} />
        </div>
      ) : (
        <div className="grid w-full place-items-center">
          <Spinner marginY="small" />
        </div>
      )}
    </MyTISection>
  );
};

export default MyTIDataTools;
